import type { Props as TippyProps } from "tippy.js";

export interface MenuAction {
  label?: string;
  icon?: string;
  eventName: string;
  className?: string;
  visible?: boolean;
  disabled?: boolean;
  source?: string;
  html?: string;
  link?: string;
  hideWhenInactive?: boolean;
  // Text for a small pill rendered after the label (e.g. "New"). Set it to
  // render the pill; leave it unset and no pill markup is emitted. Distinct
  // from `html`, which is an arbitrary-markup escape hatch.
  badgeLabel?: string;
  // Logical group the action belongs to. ActionsMenu renders a 1px
  // divider between adjacent items whose group differs, so callers can
  // organize a long list by concern without printing per-section labels
  // (the headers were noisy when only some sections had them).
  group?: string;
}

export enum QuoteAction {
  Approve = "approve",
  ForceApprove = "force-approve",
  Schedule = "schedule",
  Decline = "decline",
  Draft = "draft",
  Propose = "propose",
  Edit = "edit",
  EditDetails = "edit-details",
  Email = "email",
  Pdf = "pdf",
  Archive = "archive",
  Unarchive = "unarchive",
  Clone = "clone",
  Reactivate = "reactivate",
  Unapprove = "unapprove"
}

export interface QuoteMenuAction extends MenuAction {
  key: QuoteAction;
}

export enum InvoiceAction {
  Approve = "approve",
  AcceptPayment = "accept-payment",
  IssueRefund = "issue-refund",
  EditPaymentSchedule = "edit-payment-schedule",
  RemovePaymentSchedule = "remove-payment-schedule",
  EditDetails = "edit-details",
  EditDate = "edit-date",
  Unapprove = "unapprove",
  Void = "void",
  ResumeBatch = "resume-batch",
  DoNotBatch = "do-not-batch",
  Download = "download",
  Resubmit = "resubmit",
  Email = "email",
  SendPayLink = "send-pay-link",
  RevokePayLink = "revoke-pay-link"
}

export interface InvoiceMenuAction extends MenuAction {
  key: InvoiceAction;
  tooltip?: string;
}

export type TippyOptions = Partial<TippyProps>;
